import { render, staticRenderFns } from "./CompTimeBenefitsCatalog.vue?vue&type=template&id=a98c7fa4&scoped=true"
import script from "./CompTimeBenefitsCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompTimeBenefitsCatalog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompTimeBenefitsCatalog.vue?vue&type=style&index=0&id=a98c7fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98c7fa4",
  null
  
)

export default component.exports